<template>
    <v-dialog :value="dialog" fullscreen persistent hide-overlay transition="dialog-bottom-transition">
        <addSupplierOfferPosition></addSupplierOfferPosition>
    </v-dialog>
</template>

<script>
    import addSupplierOfferPosition from './AddSupplierOfferPosition.vue'
    
    import {
        SupplierOfferPositions
    } from '../../../store/namespace-helper'

    export default {
      name: 'AddSupplierOfferPositionDialog',
      components: {
        addSupplierOfferPosition
      },
      data () {
        return {}
      },
      methods: {},
      computed: {
        dialog () {
          return this.$store.getters[SupplierOfferPositions.getters.getOpenDialogState]
        }
      },
      beforeDestroy () {

      }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/SupplierOffers/SupplierOfferPositions/AddSupplierOfferPositionDialog.vue